import Vue from "vue";
import {
  Button,
  Icon,
  Select,
  Pagination,
  Input,
  Modal,
  FormModel,
  message
} from "ant-design-vue";

Vue.component(Button.name, Button);
Vue.component(Icon.name, Icon);
Vue.component(Select.name, Select);
Vue.component(Pagination.name, Pagination);
Vue.component(Input.name, Input);
Vue.use(Modal);
Vue.use(FormModel);
Vue.prototype.$antMessage = message;
Vue.prototype.$antModal = Modal;
